// extracted by mini-css-extract-plugin
export default {"reportsContent":"Reports_reportsContent__Bn8ig","reportsTabs":"Reports_reportsTabs__bcChf"};